import { render, staticRenderFns } from "./PermissionCreate.vue?vue&type=template&id=55f627b9&"
import script from "./PermissionCreate.vue?vue&type=script&lang=js&"
export * from "./PermissionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports